import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faPenToSquare, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { useContext, useEffect, useMemo, useState } from "react";
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import { ToastContext } from "../../../../context/ToastContext";
import _ from "underscore";

export const useCreateScreens = ({ filterValues, setFilterValues }) => {
  const { showSuccess, showError, showInfo } = useContext(ToastContext);
  const [visible, setVisible] = useState({ show: false, delete: false });
  const [rowData, setRowData] = useState([]);
  const [loader, setLoader] = useState({})
  const [fieldValues, setFieldValues] = useState({ field_configuration_id: 0 });

  useEffect(() => {
    (filterValues?.apiCall && _.isEmpty(filterValues?.config)) && getScreenSummary();
  }, [filterValues?.apiCall])

  const columns = [
    {
      key: "name",
      label: "Name",
      style: { width: "40%" },
      render: (row) => (
        <div className="d-flex flex-column py-1 text-truncate w90">
          <span className=" " >{row.screen_name} </span>
          <small className="text-truncate fw-semibold" >{row.screen_description} </small>
        </div>
      )
    },
    {
      key: "schemes",
      label: "Schemes",
      style: { width: "35%" },
      render: (row) => (
        <div className="d-flex flex-column flex-wrap gap-1 py-2">
          {
            row?.schemes?.map((val) => {
              return <div
                className="text-primary bg-light text-truncate round-small-section"
                onClick={() => setFilterValues((prev) => ({ ...prev, tab: "screens_schemes", apiCall: true }))}
              >
                <FontAwesomeIcon icon="fa-solid fa-link" /> {val?.scheme_name}
              </div>
            })
          }

        </div>
      )
    },
    {
      key: "actions",
      label: "Actions",
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center", width: "25%" },
      render: (row) => {
        const handleAction = (isCopy = false) => {
          setFieldValues({
            ...row,
            screen_id: isCopy ? 0 : row.screen_id,
            screen_name: isCopy ? `Copy of ${row?.screen_name}` : row?.screen_name,
            isChange: false
          });

          setVisible((prev) => ({ ...prev, show: true, isCopy, row }));
        };

        return (
          <div className="d-flex justify-content-center gap-3">
            <FontAwesomeIcon
              icon="fa-solid fa-sliders"
              className="text-primary c-pointer"
              onClick={() => {
                setFilterValues((prev) => ({ ...prev, apiCall: true, config: row }));
              }}
            />
            <FontAwesomeIcon
              icon={faPenToSquare}
              className="text-primary c-pointer"
              onClick={() => handleAction(false)}
            />
            <FontAwesomeIcon
              icon={faCopy}
              className="text-gray c-pointer"
              onClick={() => handleAction(true)}
            />
            {
              <FontAwesomeIcon
                icon={faTrashCan}
                className={` ${row?.is_screen_mapped ? "text-gray user-select-auto" : "text-danger  c-pointer"}`}
                onClick={() => setVisible((prev) => ({ ...prev, delete: true, data: row }))}
              />
            }

          </div>
        );
      }
    }
  ];

  const formJson = [
    {
      label: "Name",
      name: "screen_name",
      col: "12",
      type: "text",
      required: true,
    },

    {
      label: "Description",
      name: "screen_description",
      col: "12",
      type: "text",
      required: false,
    },
  ]

  const getScreenSummary = async () => {
    try {
      setLoader({ grid: true })
      const res = await services.getInvokeRemote("GET", Urls("GETSCREENCONFIGURATIONSUMMARY"));
      if (!res?.body?.error_status) {
        const result = Object.values(res?.body?.data?.screen_configuration_list?.reduce((acc, item) => {
          const id = item.screen_id;
          if (!acc[id]) {
            acc[id] = {
              ...item,
              schemes: []
            };
            delete acc[id].screen_scheme_id;
            delete acc[id].screen_scheme_name;
          }

          item.screen_scheme_id && acc[id].schemes.push({
            scheme_id: item.screen_scheme_id,
            scheme_name: item.screen_scheme_name
          });

          return acc;
        }, {}));
        setRowData(result)
      } else {
        setRowData([])
      }
    } catch (error) {
      console.error("error::", error)
    } finally {
      setLoader({ grid: false })
      setFilterValues((prev) => ({ ...prev, apiCall: false }))
    }
  }

  const handleChange = (item, e) => {
    setFieldValues((prev) => ({ ...prev, [item?.name]: e.target.value, isChange: true }));
  }

  const upsertScreen = async (isDelete, ids) => {

    try {
      setLoader((prev) => ({ ...prev, btn: true }))

      let names = _.pluck(rowData, "screen_name")?.map(item => item?.toLowerCase()?.trim());
      if (!_.isEmpty(visible?.row) && !visible?.isCopy) {
        names = _.filter(names, item => item !== visible?.row?.screen_name?.toLowerCase()?.trim());
      }
      if (!fieldValues?.screen_name?.trim() && !isDelete) {
        showInfo("Info", "Please enter screen name.");
        return;
      }
      if (fieldValues?.screen_name?.trim() && names?.includes(fieldValues?.screen_name?.toLowerCase()?.trim()) && !isDelete) {
        showInfo("Info", "This screen name is already exist.");
        return;
      }
      if ((!fieldValues?.isChange || (fieldValues?.isChange && visible?.row?.screen_name?.trim() === fieldValues?.screen_name?.trim() && visible?.row?.screen_description?.trim() === fieldValues?.screen_description?.trim())) && !isDelete && !visible.isCopy) {
        showInfo("info", "No changes made.");
        return;
      }
      let payload = {}
      let url = ""
      if (visible?.copy) {
        url = "UPSERTSCREENCONFIGURATIONCOPY"
        payload = {
          "screen_id": fieldValues?.screen_id || 0,
          "screen_name": fieldValues?.screen_name || "",
          "screen_description": fieldValues?.screen_description || "",
        }
      } else {
        url = "UPSERTSCREENCONFIGURATION"
        payload = {
          "screen_id": isDelete ? visible?.data?.screen_id : fieldValues?.screen_id || 0,
          "screen_name": fieldValues?.screen_name || "",
          "screen_description": fieldValues?.screen_description || "",
          "is_deleted": isDelete || false
        }
      }

      const res = await services.getInvokeRemote("POST", Urls(url), payload);
      if (!res?.body?.error_status) {
        showSuccess('Sucess', res.body.message)
        if (isDelete) {
          setRowData(prevData =>
            prevData.filter(item => item.screen_id !== visible?.data.screen_id)
          );
        } else {
          setFieldValues({ isChange: false })
          setFilterValues((prev) => ({ ...prev, apiCall: true }))
        }
        setVisible((perv) => ({ ...perv, show: false, delete: false }))
      } else {
        showError("Error", res.body.message);
      }
    } catch (error) {
      console.error("error::", error)
    } finally {
      setLoader((prev) => ({ ...prev, btn: false }))
    }
  }

  const filteredData = useMemo(() => {
    if (!filterValues?.search?.trim()) return rowData;

    return rowData?.filter((item) =>
      item?.screen_name
        ?.toLowerCase()
        .includes(filterValues?.search.toLowerCase())
    );
  }, [rowData, filterValues?.search]);

  return {
    columns, rowData: filteredData, visible, setVisible, fieldValues, setFieldValues, handleChange, formJson, upsertScreen, loader
  }
}